export default {
  FINALIZADO: 1,
  FALHA: 2,
  EM_ANDAMENTO: 3,
  DESABILITADO: 4,
  DESCONHECIDO: 5,
  ERRO: 6
};
